module.exports = __webpack_public_path__ + "media/de_de_s3_Liezel.b3d10d60.mp3";